/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Set_MasterInputs */

const en_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set master resume`)
};

const de_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master-Lebenslauf festlegen`)
};

const fr_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir le CV principal`)
};

const es_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer currículum principal`)
};

const it_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta curriculum vitae principale`)
};

const nl_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel master cv in`)
};

const pl_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustaw główne CV`)
};

const fi_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aseta pääansiotodistus`)
};

const da_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indstil hoved-CV`)
};

const sv_dashboard_step_set_master = /** @type {(inputs: Dashboard_Step_Set_MasterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ställ in huvud-CV`)
};

/**
* | output |
* | --- |
* | "Set master resume" |
*
* @param {Dashboard_Step_Set_MasterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_set_master = /** @type {((inputs?: Dashboard_Step_Set_MasterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Set_MasterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_set_master(inputs)
	if (locale === "fr") return fr_dashboard_step_set_master(inputs)
	if (locale === "es") return es_dashboard_step_set_master(inputs)
	if (locale === "it") return it_dashboard_step_set_master(inputs)
	if (locale === "nl") return nl_dashboard_step_set_master(inputs)
	if (locale === "pl") return pl_dashboard_step_set_master(inputs)
	if (locale === "fi") return fi_dashboard_step_set_master(inputs)
	if (locale === "da") return da_dashboard_step_set_master(inputs)
	if (locale === "sv") return sv_dashboard_step_set_master(inputs)
	return en_dashboard_step_set_master(inputs)
});